import { __assign } from "tslib";
import React, { forwardRef, useLayoutEffect, useMemo, useRef } from 'react';
import { useUtils as useMuiUtils } from '@material-ui/pickers';
import { useEventCallback, useForkRef, useKeyboardMoveFocus, useOnlyOneFocusable, } from '../../../../foundation';
import { YearsWrapper } from './styles';
import { Year } from './Year';
var Years = forwardRef(function (props, ref) {
    var _a;
    var date = props.date, onYearChange = props.onYearChange, minDate = props.minDate, size = props.size, maxDate = props.maxDate, disablePast = props.disablePast, disableFuture = props.disableFuture, now = props.now;
    var utils = useMuiUtils();
    var containerRef = useRef(null);
    var combineRef = useForkRef(containerRef, ref);
    var selectedYearRef = useRef(null);
    var currentYear = utils.getYear(date || now);
    var years = useMemo(function () { return utils.getYearRange(minDate, maxDate); }, [maxDate, minDate, utils]);
    var onYearSelect = useEventCallback(function (year) {
        var newDate = utils.setYear(date, year);
        onYearChange(newDate);
    });
    var focusedIndexRef = useRef(0);
    var focusedYear = (_a = years[focusedIndexRef.current]) === null || _a === void 0 ? void 0 : _a.year();
    var _b = useOnlyOneFocusable({
        focusedIndexRef: focusedIndexRef,
        containerRef: containerRef,
    }), focusIndex = _b.focusIndex, getItemProps = _b.getItemProps;
    var getOptionDisabled = function (year) {
        return Boolean((disablePast && utils.isBeforeYear(year, now)) ||
            (disableFuture && utils.isAfterYear(year, now)));
    };
    var columns = size === 'small' ? 2 : 4;
    var handleKeyDown = useKeyboardMoveFocus({
        options: years,
        focusedIndexRef: focusedIndexRef,
        columns: columns,
        infinite: 'order',
        onFocusedIndexChange: function (event, toIndex) {
            focusIndex(toIndex);
            event === null || event === void 0 ? void 0 : event.preventDefault();
        },
        getOptionDisabled: getOptionDisabled,
    }).onKeyFocusedIndexHandle;
    useLayoutEffect(function () {
        var index = years.findIndex(function (x) { return utils.getYear(x) === currentYear; });
        focusIndex(index);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return (React.createElement(YearsWrapper, { role: "presentation", "aria-label": " ", columns: columns, ref: combineRef, onKeyDown: handleKeyDown }, years.map(function (year, index) {
        var yearNumber = utils.getYear(year);
        var selected = yearNumber === currentYear;
        var focused = yearNumber === focusedYear;
        var disabled = getOptionDisabled(year);
        return (React.createElement("li", { key: utils.getYearText(year) },
            React.createElement(Year, __assign({}, getItemProps(index), { ref: focused ? selectedYearRef : undefined, key: utils.getYearText(year), selected: selected, focused: yearNumber === focusedYear, value: yearNumber, onSelect: onYearSelect, disabled: disabled }), utils.getYearText(year))));
    })));
});
Years.displayName = 'RcYears';
export { Years };
